import { ArrowLeft } from 'lucide-react';
import { useSeo } from '@/components/Seo';
import { useLang, LangLink } from '@/i18n/LangContext';

export default function NotFound() {
  const { t } = useLang();
  useSeo({ title: t('notFoundTitle'), description: t('notFoundText'), robots: 'noindex,nofollow' });

  return (
    <div data-testid="not-found-page" className="flex flex-1 items-center justify-center px-5 py-16 text-center md:px-8">
      <div className="mx-auto max-w-site">
        <p className="font-heading text-7xl md:text-9xl font-bold text-brand-light/60 tracking-tighter mb-6">404</p>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mb-4">{t('notFoundTitle')}</h1>
        <p className="text-foreground/70 mb-10 max-w-md mx-auto">{t('notFoundText')}</p>
        <LangLink
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-7 py-4 text-sm font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('notFoundButton')}
        </LangLink>
      </div>
    </div>
  );
}
